var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invalid-feedback"},[(_vm.errors)?_c('div',{staticClass:"invalid-feedback__msg_list"},_vm._l((_vm.errors),function(msg,i){return _c('div',{key:i,staticClass:"invalid-feedback__msg_item"},[_vm._v(" "+_vm._s(msg)+" ")])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }